let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fioRI")).then(() => parcelRequire('i1QAp'));